import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import { Card, Grid } from "@mui/material";
import axios from "axios";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";

export default class Universities extends Component {
  state = {
    colleges: [],
    message: "",
    notification: false,
    noticolor: "success",
    pagination: {
      page: 1,
      totalPages: 1,
      totalDocs: 0,
    },
    per_page: 20,
    page_no: 1,
    redirect: false,
  };

  componentDidMount() {
    this.getAllUniversities(this.state.page_no, this.state.per_page);
  }

  getAllUniversities = (page, limit) => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    axios
      .get(`${Constants.getUrls.getAllUniversities}?page=${page}&limit=${limit}`)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({
            colleges: resp.data.data.docs,
            pagination: resp.data.data,
            page_no: resp.data.data.page,
          });
        }
      })
      .catch((err) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: err?.response?.data?.message || "Failed to fetch colleges.",
        });
      });
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllUniversities(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllUniversities(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    axios
      .delete(Constants.deleteUrls.deleteUniversity + id)
      .then((resp) => {
        this.setState({
          notification: true,
          noticolor: "success",
          message: resp.data.message,
        });
        setTimeout(() => {
          this.setState({ notification: false, message: "" });
          this.getAllUniversities(this.state.page_no, this.state.per_page);
        }, 2000);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          noticolor: "error",
          message: err?.response?.data?.message || "Failed to delete college.",
        });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/signin" replace={true} />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Colleges
              </MDTypography>
            </MDBox>
            <Grid item sm={4} px={2} align="right">
              <Link to="/addCollege">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>
            <MDBox>
              <DataTable
                table={{
                  columns: [
                    { Header: "serial", accessor: "serial", width: "6%" },
                    { Header: "college name", accessor: "name" },
                    { Header: "short name", accessor: "short_name" },
                    { Header: "city", accessor: "city" },
                    { Header: "state", accessor: "state" },
                    { Header: "status", accessor: "status" },
                    { Header: "action", accessor: "action" },
                  ],
                  rows: this.state.colleges.map((item, index) => ({
                    serial: index + 1,
                    name: item.name,
                    short_name: item.short_name || "-",
                    city: item.city || "-",
                    state: item.state || "-",
                    status: item.status,
                    action: (
                      <>
                        <div>
                          <Link to={`/updateCollege/${item._id}`}>
                            <MDButton variant="outlined" size="small" color="success">
                              Update
                            </MDButton>
                          </Link>
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => this.handleDelete(item._id)}
                          >
                            Delete
                          </MDButton>
                        </div>
                      </>
                    ),
                  })),
                }}
                entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                page_no={this.state.pagination?.page}
                totalPages={this.state.pagination?.totalPages}
                totalDocs={this.state.pagination?.totalDocs}
                onPageChange={this.handlePageChange}
                onEntriesPerPageChange={this.handleEntriesPerPageChange}
              />
            </MDBox>
            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
